<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card class="primary darken-1">
          <v-row class="ml-2">
            <v-col cols="12" class="ml-0 mr-2">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span v-if="avarageUsefulVolume && avarageUsefulVolume.updated" style="color: lightgrey; font-size: small">Atualizado em {{avarageUsefulVolume.updated}}</span>
              <span v-else style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary lighten-1" class="mb-2" size="24">
              mdi-database-outline
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">Volume</v-card-subtitle>
          <v-card-text>
            <v-row v-if="avarageUsefulVolume" class="white--text" align="center">
                <v-col class="pr-0" cols="12">
                    <strong class="value-text">{{avarageUsefulVolume.value}}</strong>
                    <span class="ml-1 unit-measurement-text">hm³</span>
                </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col class="pa-3" cols="12">
                <h2>Em breve</h2>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="primary darken-1">
          <v-row class="ml-2">
            <v-col cols="12" class="ml-0 mr-2">
              <v-icon style="color: lightgrey" left small>restore</v-icon>
              <span v-if="avarageUsefulVolumePercentage && avarageUsefulVolumePercentage.updated" style="color: lightgrey; font-size: small">Atualizado em {{avarageUsefulVolumePercentage.updated}}</span>
              <span v-else style="color: lightgrey; font-size: small">Atualizado em ##/##/####</span>
            </v-col>
          </v-row>
          <v-card-title class="mt-n5">
            <v-icon color="secondary lighten-1" class="mb-2" size="24">
              mdi-water-percent
            </v-icon>
          </v-card-title>
          <v-card-subtitle class="font-weight-bold white--text">
            Volume útil
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-icon size="medium" right v-bind="attrs" v-on="on">mdi-help-circle-outline</v-icon>
              </template>
              <span><b>Observação:</b>a porcentagem exibida no <b>card</b> é calculada com base no <b>volume útil</b> do reservatório.</span>
            </v-tooltip>
          </v-card-subtitle>
          <v-card-text>
            <v-row v-if="avarageUsefulVolumePercentage" class="white--text" align="center">
                <v-col class="pr-0" cols="12">
                    <strong class="value-text">{{avarageUsefulVolumePercentage.value}}</strong>
                    <span class="ml-1 unit-measurement-text">%</span>
                </v-col>
            </v-row>
            <v-row v-else class="white--text">
              <v-col class="pa-3" cols="12">
                <h2>Em breve</h2>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="hidden-sm-and-down" cols="12" sm="6" md="6">
            <v-card class="primary darken-1">
                <v-row v-if="accumulatedRainOfMonth" class="ml-1">
                    <v-col cols="12" class="ml-1">
                    <v-icon style="color: lightgrey" left small>restore</v-icon>
                    <span style="color: lightgrey; font-size: small">Atualizado em {{accumulatedRainOfMonth.updated}}</span>
                    </v-col>
                </v-row>
                <v-card-title class="mt-n5">
                    <v-icon color="secondary lighten-1" class="mb-2" size="24">
                    mdi-weather-pouring
                    </v-icon>
                </v-card-title>
                <v-card-subtitle class="font-weight-bold white--text">Chuva do mês atual</v-card-subtitle>
                <v-card-text>
                    <v-row v-if="accumulatedRainOfMonth" class="white--text">
                        <v-col class="pr-0" cols="6" style="max-width: 160px;">
                            <strong class="value-text">{{accumulatedRainOfMonth.value}}</strong>
                            <span class="ml-1 unit-measurement-text">mm</span>
                        </v-col>
                        <v-col class="pr-0" cols="6">
                            <span>Acumulado do mês de {{currentMonthFormat}}</span>
                        </v-col>
                    </v-row>
                    <v-row v-else class="white--text">
                      <v-col class="pa-3" cols="12">
                          <h2>Em breve</h2>
                      </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ['avarageUsefulVolume', 'avarageUsefulVolumePercentage', 'accumulatedRainOfMonth', 'currentMonthFormat'],
  name: "SaicPrecipitationData",
}
</script>

<style scoped>
  .v-card.v-sheet.theme--dark {
    min-height: 180px;
    max-height: 300px;
  }

  .unit-measurement-text{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
  }

  .value-text{
      font-family: Roboto;
      font-style: normal;
      font-weight: bold;
      font-size: 40px;
      line-height: 47px;
  }
</style>
